// import Orders from '../../api/order'

// initial state
const state = () => ({
  orders: []
})

// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
